import { Pipe, PipeTransform } from '@angular/core';

import { MimeTypesDict } from '@models/module/fields/main';

@Pipe({
  name: 'getMimeType',
})
export class GetMimeTypePipe implements PipeTransform {
  transform(filenames: string): string {
    if (!filenames) {
      return null;
    }
    const filename = filenames.split(',')[0];
    const extension = filename.split('.').pop()?.toLowerCase();
    return MimeTypesDict[extension];
  }
}
